import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Grid,
  CardMedia,
  Box,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import ownBuilding from "../../assets/images/property.png";
import propertyService from "../../services/owner-services/propertyService";

const Properties = () => {
  const [properties, setProperties] = useState([]);
  const [expandedIds, setExpandedIds] = useState([]);

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const res = await propertyService.getDistinctProperties();
        if (res.data?.isSuccess && Array.isArray(res.data.result)) {
          setProperties(res.data.result);

          // open all by default
          setExpandedIds(res.data.result.map((p) => p.id));
        }
      } catch (error) {
        console.error("Error fetching properties:", error);
      }
    };

    fetchProperties();
  }, []);

  const handleToggle = (id) => {
    if (expandedIds.includes(id)) {
      setExpandedIds(expandedIds.filter((i) => i !== id));
    } else {
      setExpandedIds([...expandedIds, id]);
    }
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom fontWeight="bold">
        My Properties
      </Typography>
      {properties.length === 0 ? (
        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          No properties to assign
        </Typography>
      ) : (
        properties.map((property) => (
          <Accordion
            key={property.id}
            expanded={expandedIds.includes(property.id)}
            onChange={() => handleToggle(property.id)}
            sx={{
              mb: 2,
              borderRadius: 3,
              overflow: "hidden",
              boxShadow: 4,
              "&:before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{ bgcolor: "grey.100", "&:hover": { bgcolor: "grey.200" } }}
            >
              <Typography variant="subtitle1" fontWeight="bold">
                {property.propertyName}
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ p: 3 }}>
              <Grid container spacing={3} alignItems="center">
                {/* Image */}
                <Grid item xs={12} sm={4}>
                  <CardMedia
                    component="img"
                    sx={{
                      height: 160,
                      width: "100%",
                      borderRadius: 3,
                      objectFit: "cover",
                    }}
                    image={property.imageUrl || ownBuilding} // ✅ default fallback
                    alt={property.propertyName}
                  />
                </Grid>

                {/* Details */}
                <Grid item xs={12} sm={8}>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {property.propertyName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Location: {property.propertyLocation}, {property.city}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Address: {property.propertyAddress}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      No of Flats: {property.noOfFlats}
                    </Typography>
                  </Box>

                  <Divider sx={{ mb: 2 }} />

                  <Grid container spacing={2}>
                    <Grid item>
                      <Button
                        component={Link}
                        to={`/owner-account/owner-property/${property.propertyGuid}`}
                        variant="contained"
                        size="small"
                        sx={{
                          borderRadius: "20px",
                          textTransform: "none",
                          px: 3,
                          bgcolor: "black",
                        }}
                      >
                        Flat Details
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        component={Link}
                        to={`/owner-account/owner-profile-agreement/${property.propertyGuid}`}
                        variant="outlined"
                        size="small"
                        sx={{
                          borderRadius: "20px",
                          textTransform: "none",
                          px: 3,
                          color: "black",
                          borderColor: "black",
                        }}
                      >
                        View Agreement
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        ))
      )}
    </Box>
  );
};

export default Properties;
